import React from 'react';
import * as Yup from 'yup';
import { CloudFolderLink, Field, Form } from '~/components';
import SettingsFormSection from '../../SettingsFormSection';

export default function CloudFolder({ formik }) {
  return (
    <SettingsFormSection title="Cloud Folder">
      <Form.Control help="Assign a shared cloud folder to this project to let team members view files.">
        <div>
          <Field.Text name="cloudFolderUrl" placeholder="Cloud Folder URL" maxLength={1024} />
        </div>

        {!!formik.values.cloudFolderUrl && Yup.string().url().isValidSync(formik.values.cloudFolderUrl) && (
          <div style={{ flex: '0 0 3rem', alignSelf: 'center' }}>
            <CloudFolderLink url={formik.values.cloudFolderUrl} />
          </div>
        )}
      </Form.Control>
    </SettingsFormSection>
  );
}
